import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function NovedadesRemitoRechazado() {
  return (
    <ClipperPlaceholder title="Remito Rechazado" category="Novedades" />
  );
}
